module.exports = __webpack_public_path__ + "static/media/BookReviewColorStudy1.c6d07daf.jpg";